<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.49264 12.7961L20.4271 12.7961C20.8644 12.7961 21.2197 12.4418 21.2197 12.0045C21.2197 11.5671 20.8644 11.2118 20.4271 11.2118L5.49264 11.2118L11.5307 5.17376C11.8399 4.8645 11.8399 4.36208 11.5307 4.05283C11.2214 3.74357 10.72 3.74357 10.4107 4.05282L3.01956 11.444C2.92448 11.5391 2.85844 11.6522 2.82141 11.7723L2.82141 11.7733L2.82141 11.7743L2.82141 11.7753C2.80139 11.8413 2.78938 11.9124 2.78738 11.9844L2.78738 11.9854L2.78738 11.9884L2.78738 11.9894L2.78738 11.9914L2.78738 11.9934L2.78738 11.9944L2.78738 11.9964L2.78738 11.9994L2.78738 12.0044C2.78738 12.0054 2.78738 12.0075 2.78738 12.0095L2.78738 12.0114L2.78738 12.0135L2.78738 12.0145L2.78738 12.0175L2.78738 12.0185L2.78738 12.0195L2.78738 12.0225L2.78738 12.0235C2.78938 12.0955 2.80139 12.1666 2.82141 12.2326L2.82141 12.2346L2.82141 12.2356C2.85844 12.3557 2.92448 12.4688 3.01956 12.5639L10.4107 19.9551C10.72 20.2643 11.2214 20.2643 11.5307 19.9551C11.8399 19.6458 11.8399 19.1444 11.5307 18.8351L5.49264 12.7961Z"
      fill="black"
    />
  </svg>
</template>

<script>
export default {
  name: 'DashboardArrowLeft'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
